// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","6596":"feb8283f","8114":"213c7715","8238":"31edac19"}[chunkId] + ".chunk.css";
};